export default __webpack_public_path__ + "static/media/ptero.a655728b.png";